import { t } from 'i18next';
import * as yup from 'yup';

import { usePostWithdrawalsRequest } from 'services/hooks/withdrawal';
import { formatKoreanNumber } from 'utils/number/formatKoreanNumber';
import { translation } from 'utils/translation';

import AvailableModal from './AvailableModal';

export interface WithdrawalData {
  // availableAfterTaxWithdrawal: number;
  minAmount: number;
  maxAmount: number;
  goodsUnit: number;
}

export const withdrawalSchema = (data: WithdrawalData) =>
  yup.object({
    withdrawalAmount: yup
      .number()
      .typeError('출금 금액은 숫자만 입력하세요.')
      .required('출금액을 입력해주세요')
      .test(
        'is-non-zero',
        `출금은 ${data.minAmount.toLocaleString()}원 단위로 가능해요.`,
        (value) => !!value && value !== 0
      )

      .test(
        'max-amount-validation',
        `출금은 한 번에 ${formatKoreanNumber(data.maxAmount)}원까지 가능해요.`,
        // `출금은 한 번에 ${formatKoreanNumber(1500000) }원까지 가능해요.`,
        (value) => !!value && value <= data.maxAmount
      )
      .test('is-multiple-of-goodsUnit', `출금은 ${data.goodsUnit.toLocaleString()}원 단위로 가능해요.`, (value) => {
        return !!value && value % data.goodsUnit === 0;
      })
      .test(
        'min-amount',
        `출금은 ${data.minAmount.toLocaleString()}원 단위로 가능해요.`,
        (value) => !!value && value >= data.minAmount
      ),
  });

const AvailableWithdrawalModal = () => {
  const { mutateAsync: postWithdrawal, isLoading: isProcessWithdrawal } = usePostWithdrawalsRequest();
  const postWithdrawalRequest = async (afterTaxAmount: number) => {
    await postWithdrawal({
      afterTaxAmount,
      type: 'cash-reward',
    });
  };

  return (
    <AvailableModal withdrawalSchema={withdrawalSchema} goodsUnit={10000} type="cash">
      <AvailableModal.Header title="출금 신청하기" />
      <AvailableModal.Body
        availableGoodsText={translation('chat.rewards_available_withdrawal_amount')}
        requestedGoodsText={translation('chat.rewards_withdrawal_request_amount')}
        units={[t('chat.rewards_withdrawal_currency_krw'), t('chat.rewards_withdrawal_currency_krw')]}
        GuideLineListComponent={
          <ul>
            <li>
              <p className="text emphasize">{translation('chat.rewards_withdrawal_amount_deduction')}</p>
            </li>
            <li>
              <p className="text emphasize">{translation('chat.rewards_revenue_converted_amount_help_text')}</p>
            </li>
            <li>
              <p className="text">{translation('chat.rewards_withdrawal_increments')}</p>
            </li>
            <li>
              <p className="text">{translation('chat.rewards_requests_made_date')}</p>
            </li>
          </ul>
        }
      />
      <AvailableModal.Footer
        isProcessWithdrawal={isProcessWithdrawal}
        postWithdrawalRequest={postWithdrawalRequest}
        withdrawalSuccessToastText="출금 신청이 완료되었습니다."
        withdrawalFailureToastText="출금 신청이 실패했습니다."
      />
    </AvailableModal>
  );
};

export default AvailableWithdrawalModal;
